<fieldset class="u-fade-slide-in">
  <h4>{{ 'publication_block.header' | translate | upperFirstLetter }}</h4>
  <div>
    <h3>{{ 'publication_block.title' | translate | upperFirstLetter }}</h3>
    <p>{{ 'publication_block.subtitle' | translate | upperFirstLetter }}</p>
  </div>
  <app-input-radio-element
    [elementsList]="visiblityItemList()"
    [selectedValue]="visibilityControl.value"
    [disabled]="visibilityDisabled()"
    (valueChange)="visibilityChange($event)"
  />
  <form [formGroup]="publicationForm()">
    <div class="divider"></div>
    <div class="options-container">
      @for (mode of planningModes(); track mode) {
        @let isActive = publicationForm().get('planning')?.value === mode;
        <input type="radio" [id]="mode" [value]="mode" [formControl]="planningControl" />
        <label [for]="mode" [ngClass]="{ active: isActive }">
          <span class="radio"></span>
          <div class="label-title">
            <kin-icon
              [color]="textColor"
              [name]="mode === 'immediate' ? 'chrono_stroke' : 'agenda'"
            />
            <p class="mode-title">
              {{ 'publication_block.planning.' + mode | translate | upperFirstLetter }}
            </p>
          </div>
          <p class="advice">
            {{ 'publication_block.planning.advice.' + mode | translate | upperFirstLetter }}
          </p>
        </label>
      }
    </div>
    @if (planningControl.value === 'scheduled') {
      <div class="planning u-fade-slide-in">
        <label for="">
          <p>{{ 'publication_block.planning.date_label' | translate }} <span class="required">*</span></p>
          <input
            type="date"
            name="planning-date"
            [formControl]="planningDateControl"
            [class.input-error]="
              publicationForm().hasError('planningDateRequired') && publicationForm().touched
            "
          />
        </label>

        <label for="">
          <p>{{ 'publication_block.planning.time_label' | translate: { timezone: userTimezone() } }}<span class="required">*</span></p>
          <input
            type="time"
            name="planning-time"
            [formControl]="planningTimeControl"
            [class.input-error]="
              publicationForm().hasError('planningTimeRequired') && publicationForm().touched
            "
          />
        </label>
        <p>{{ 'publication_block.planning.approval_notice' | translate }}</p>
      </div>
    }
  </form>
</fieldset>
